import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAPI } from '../../api';
import { useAuth } from '../../auth/AuthProvider';
import { AuthProfile, ProfileResponse } from 'types';

const AuthComplete = () => {
	const api = useAPI();
	const auth = useAuth();

	const navigate = useNavigate();

	useEffect(() => {
		api.get<ProfileResponse>('/api/auth/profile')
		.then(json => {
			if (json.user) {
				const loginTarget = localStorage.getItem('afterlogintarget') || '/';
				localStorage.removeItem('afterlogintarget');

				auth?.update(json as AuthProfile);
				navigate(loginTarget);
			} else {
				auth?.clear();
				navigate('/auth/login');
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<p>Completing Authentication...</p>
		</div>
	);
};

export default AuthComplete;
